module.exports = __webpack_public_path__ + "static/media/smk_logo.fd6f60ee.png";